module.exports = __webpack_public_path__ + "static/media/SIG18.63db5b88.png";